module.exports = new __parcel__URL__("step_one_vector_dark.3cae4867.png").toString();